import {AfterViewInit, Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {StoreSelectorsService} from "../../../services";
import {IAppStatic, ICartCreate, ICartProduct, IUser} from "../../../interfaces";
import {MatDialog} from "@angular/material/dialog";
import {Compbaser} from "../../../components/compbaser";
import {faAmazon} from '@fortawesome/free-brands-svg-icons';
import {ADZ, lastDateMonth} from "../../../common";
import * as _ from "lodash";

@Component({
    selector: 'app-product',
    styleUrls: [`./product.component.scss`],
    templateUrl: './product.component.html',
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({opacity: 0}),
                        animate('1.5s ease-out',
                            style({opacity: 1}))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({opacity: 1}),
                        animate('1.5s ease-in',
                            style({opacity: 0}))
                    ]
                )
            ]
        )
    ]
})

export class ProductComponent extends Compbaser implements AfterViewInit {
    // cartProducts: Array<ICartProduct> = [];
    cartCreate: ICartCreate;
    addedProduct: string = null;
    user: IUser;
    selectedThumb;
    productImages;
    currentRoute = '';
    stringJSPipeArgs = {toCurrency: ['us', 0]};
    appStatic: IAppStatic;
    faAmazon = faAmazon;
    ADZ = ADZ;
    onSaleEnd: string;
    // Amazon special offer / special deal for good rating
    // mediaDROID+ Powered by The Free Cloud Signage from DigitalSignage.com…
    // B076X6H2KR
    onSaleActive = false;

    @Input() cartProduct: ICartProduct;
    @ViewChild("thumbDialogModal", {read: TemplateRef}) thumbDialogModal: TemplateRef<any>;

    constructor(protected override dialog: MatDialog,
                private router: Router,
                private route: ActivatedRoute,
                private storeSelector: StoreSelectorsService,
    ) {
        super();
        this.onSaleEnd = lastDateMonth('MM/DD/yy');
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((appStatic) => {
                    this.appStatic = appStatic;
                    this.productImages = appStatic.productImages;
                })
        );
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                // this.enterpriseMode = i_user.enterprise;
                // this.dashboard = i_user.dashboard;
                this.user = user;
            })
        );
    }

    ngAfterViewInit() {
        this.currentRoute = this.router.url;
    }

    onThumbSelected(cartProduct: ICartProduct, index) {
        this.selectedThumb = cartProduct[`image_thumb_${index}`];
        this.dialog.open(this.thumbDialogModal);
    }

    onImageSelected(cartProduct: ICartProduct) {
        this.selectedThumb = cartProduct.image;
        this.dialog.open(this.thumbDialogModal);
    }

    onBuyAtAmazon(e) {
        window.open(this.appStatic.amazonOffer, "_blank");
        e.preventDefault();
        e.stopImmediatePropagation();
    }

    onAddCartNav(product: ICartProduct) {
        // const routeTo = this.isProductInUrl() ? `../../list/${product.product_id}:${_.uniqueId()}` : `../list/${product.product_id}:${_.uniqueId()}`;
        if (this.currentRoute.indexOf('shopping-cart') > -1) {
            this.router.navigate([`../list/${product.product_id}:${_.uniqueId()}`], {relativeTo: this.route});
        } else {
            this.router.navigate([`shopping/list/${product.product_id}:${_.uniqueId()}`]);
        }
    }

    navigateTo(link) {
        switch (link) {
            case 'checkout': {
                this.router.navigate(['../checkout'], {relativeTo: this.route});
                break;
            }
            case 'cart': {
                this.router.navigate(['../list'], {relativeTo: this.route});
                break;
            }

        }
    }
}

// this.cod(
//     combineLatest([this.route.queryParams, this.storeSelector.getCartProducts()]).pipe(
//         map(([params, products]) => ({params, products}))
//     ).subscribe((v) => {
//         if (v && v.products) {
//             this.cartProducts = v.products.filter((p) => {
//                 return p.product_id != MS_15;
//             });
//             if (v.params && v.params['s']) {
//                 setTimeout(() => {
//                     const itemToScrollTo = document.getElementById(v.params['s']);
//                     // null check to ensure that the element actually exists
//                     if (itemToScrollTo) {
//                         itemToScrollTo.scrollIntoView(true);
//                     }
//                 }, 100);
//             }
//         }
//     })
// );
// this.cod(
//     this.route.paramMap.subscribe((routeParams) => {
//         if (routeParams.get('id')) {
//             this.onAddCart(routeParams.get('id'));
//         }
//     })
// );
